// extracted by mini-css-extract-plugin
export var contentBody = "_42-9";
export var headerImage = "_42-2";
export var imageButton = "_42-7";
export var imageButtonIcon = "_42-8";
export var imageHeader = "_42-4";
export var imageHeaderText = "_42-5";
export var imageOverlay = "_42-3";
export var imageTitle = "_42-6";
export var imageWrapper = "_42-1";
export var taskList = "_42-a";
export var widget = "_42-0";